import {
  COUNTRY_ABBR_INDONESIA,
  COUNTRY_ABBR_SINGAPORE,
  COUNTRY_ABBR_VIETNAM,
  COUNTRY_ID_INDONESIA,
  COUNTRY_ID_SINGAPORE,
  COUNTRY_ID_VIETNAM,
} from '@utils/constants/countries.constants';

export const getCountryAbbrFromCountryID = (id: number): string => {
  switch (id) {
    case COUNTRY_ID_SINGAPORE:
      return COUNTRY_ABBR_SINGAPORE;
    case COUNTRY_ID_INDONESIA:
      return COUNTRY_ABBR_INDONESIA;
    case COUNTRY_ID_VIETNAM:
      return COUNTRY_ABBR_VIETNAM;
    default:
      return id.toString();
  }
};
